export const GRAPH_CURRENT_TIME_TEXT = 'Текущее время';
export const GRAPH_TIME_OFFSET = 160;
export const GRAPH_SIZE = 60;
export const GRAPH_LABEL_FOR_TOOLTIP = 'Открытие двери';

//Нужна для графика 'открытие двери', чтобы задать ей размерность на графике, т.к. с бэка приходит 1 и 0
export const GRAPH_OPEN_DOOR_SIZE = 50;
